/**
 * @author HungNS
 */
/* eslint-disable no-unused-vars */

import IConstants from "@/common/constants/IConstants.js";

const NewsPlugin = {
    install(Vue, options) {
        Vue.prototype.colorMessageKind = function (
            messageKind,
            listMessageKind = IConstants.MESSAGE_KIND
        ) {
            if (messageKind == listMessageKind.NOTIFICATION) {
                return "label btn-xs notify-type btn-primary";
            } else if (messageKind == listMessageKind.IMPORTANT) {
                return "label btn-xs notify-type btn-danger";
            } else if (messageKind == listMessageKind.CAMPAIGN) {
                return "label btn-xs notify-type btn-warning";
            } else if (messageKind == listMessageKind.SEMINAR) {
                return "label btn-xs notify-type btn-success";
            } else if (messageKind == listMessageKind.MAINTENANCE) {
                return "label btn-xs notify-type btn-violet";
            } else if (messageKind == listMessageKind.OTHER) {
                return "label btn-xs notify-type btn-inverse";
            }
        };
        Vue.prototype.isCloseBtn = function (item) {
            if(!item || item.messageType == undefined || item.readFlg == undefined) return false;
            else return item.messageType == 0 ? true : item.readFlg == 1 ? true : false;
        };
        Vue.prototype.isRead = function(readFlg){
            if (IConstants.READ_FLG.READ == readFlg) {
                return IConstants.MARK_AS_READ_CLASS.READ;
            } else{
                return IConstants.MARK_AS_READ_CLASS.UNREAD;
            }
        };
        Vue.prototype.prepareDataToOpenNewsInfo = function (item, isAgreementNews, callbackFunction) {
            let option = {
                isAgreementNew: isAgreementNews
            };
            if(Array.isArray(item)){
                option.item = item;
            } else option.item = new Array(item);

            option.callbackFunction = callbackFunction;

            return option;
        };

    },
};

export default NewsPlugin;
